import React, { useEffect, useState } from 'react';
import MDButton from 'components/MDButton';
import MDModal from 'components/MDModal';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDInput from 'components/MDInput';
import { useAppServices, useUploadImage } from 'hook/services';
import { useAgencyInfo } from 'context/agency';
import { Button, Stack, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Editor from 'components/editor';

const CreateModal = ({ handleRefresh }) => {
  const [openAddProduct, setOpenAddProduct] = useState(false);
  const [description, setDescription] = useState('');
  // const [transcription, setTranscription] = useState('');
  const [processing, setProcessing] = useState(false);
  const [images, setImages] = useState([]);
  const uploadImage = useUploadImage();
  const [agency] = useAgencyInfo();
  const AppService = useAppServices();

  const handleModal = () => setOpenAddProduct(true);
  const closeAddProduct = () => {
    setOpenAddProduct(false);
    setImages([]);
  };

  const handleImageChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    setImages((prev) => [...prev, ...selectedFiles]);
  };

  const handleRemove = (idx) => {
    setImages((prev) => prev.filter((_, i) => i !== idx));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setProcessing(true);

    let image_responses = [];
    if (images.length) {
      image_responses = await Promise.all(
        images.map((file) =>
          uploadImage({ file, desiredPath: `app/logo/image` })
        )
      );
    }

    const payload = {
      description,
      image: image_responses.map((r) => r?.response?.data),
      // video: e.target.video.value,
      // transcription,
      path: e.target.path.value,
      type: e.target.type.value,
    };

    const { response } = await AppService.aisupprortkb.create({ payload });
    if (response) {
      setProcessing(false);
      closeAddProduct();
      handleRefresh();
    } else {
      setProcessing(false);
    }
  };

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 700,
    maxHeight: '80vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  };

  return (
    <>
      <MDButton color="white" variant="contained" onClick={handleModal}>
        Create
      </MDButton>
      <MDModal open={openAddProduct} onClose={closeAddProduct}>
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style}>
            <MDTypography variant="h5" mb={2}>
              Create Ai Support Knowledge Base
            </MDTypography>
            <Stack direction="row" alignItems="center" spacing={2}>
              <Button variant="contained" component="label" sx={{ color: '#fff' }}>
                Upload Images +
                <input hidden multiple name="images" type="file" onChange={handleImageChange} />
              </Button>
            </Stack>
            {images.map((file, idx) => (
              <MDBox
                key={idx}
                sx={{
                  position: 'relative',
                  display: 'inline-block',
                  marginTop: 2,
                  marginRight: 2,
                }}
              >
                <img
                  src={URL.createObjectURL(file)}
                  alt="preview"
                  style={{
                    width: 60,
                    height: 60,
                    objectFit: 'cover',
                    display: 'block',
                  }}
                />
                <IconButton
                  size="small"
                  sx={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    backgroundColor: 'white',
                    ':hover': { backgroundColor: 'red' },
                  }}
                  onClick={() => handleRemove(idx)}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </MDBox>
            ))}
            <MDBox mb={2} mt={2}>
              <MDTypography variant="button">Description</MDTypography>
              <Editor handleChange={setDescription} />
            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="button">Path</MDTypography>
              <MDInput label="Path" name="path" fullWidth />
            </MDBox>
            {/* <MDBox mb={2}>
              <MDTypography variant="button">Transcription</MDTypography>
              <Editor handleChange={setTranscription} />
            </MDBox> */}

                        <MDBox mb={2}>
                          <MDTypography variant="button">Type</MDTypography>
                          <MDInput
                            select
                            name="type"
                            fullWidth
                            required
                            SelectProps={{ native: true }}
                          >
                            <option value="agency">Agency </option>
                            <option value="subaccount">Sub Account</option>
                          </MDInput>
                        </MDBox>
            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 2, mb: 1 }}
                onClick={closeAddProduct}
              >
                Close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 2, mb: 1, ml: 1 }}
                disabled={processing}
              >
                Add
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    </>
  );
};

export default CreateModal;
